import { Controller, type Control } from "react-hook-form";

import { Input } from "@/components/ui/input";

import { TraderDetailsProfileField } from "../TraderDetailsProfileField";
import type { TraderDetailsStepOneFormValues } from "../TraderDetailsStepOne/types";

interface TraderDetailsNameFieldProps {
  control: Control<TraderDetailsStepOneFormValues>;
  errorMessage: string;
  isDisabled?: boolean;
  label: string;
}

export const TraderDetailsNameField = ({
  control,
  errorMessage,
  isDisabled = false,
  label,
}: TraderDetailsNameFieldProps) => (
  <Controller
    control={control}
    name="name"
    rules={{
      required: true,
    }}
    render={({ field }) => (
      <TraderDetailsProfileField id="name-input" label={label} errorMessage={errorMessage} required>
        <Input
          {...field}
          id="name-input"
          value={field.value ?? ""}
          aria-invalid={!!errorMessage}
          aria-describedby={errorMessage ? "name-input-error" : undefined}
          disabled={isDisabled}
          className="border-border"
        />
      </TraderDetailsProfileField>
    )}
  />
);
